// IDs der Massenaktionen in der Talentliste. Sie stehen als id am Button der
// Select-Bar und am Tooltip. Der Talentspeicher-Guard
// (helpers/talent-storage-table.js) hängt an genau diesen Werten, die
// Produkt-Tour (components/product-tour/product-tour.js) zielt per Selektor
// darauf.
export const SPACE_ACTION_IDS = Object.freeze({
  CROSSMODE: 'action-crossmode',
  SET_SPACE_STATE: 'action-set-space-state',
  SEND_REMINDER: 'action-remind',
  DELETE_SPACE: 'action-remove',
  RESET_EXPIRED: 'action-reset-expired',
  FULL_RESET: 'action-full-reset'
})
